import { AnalyticsEventTrigger } from '@llt-frontend/react-analytics-context';
import classnames from 'classnames';
import { Button } from '@llt-frontend/react-material-button';
import { Card } from '@llt-frontend/react-material-card';
import { getHours } from '../../utilities/time';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from './repurchase/util';

// Constants
const ANALYTICS_CATEGORY = 'tutoring-packages';

function _GetTitle(t, tier, durationSeconds) {
  const hours = getHours(durationSeconds);
  return t && t('packageTitle', { tier, hours });
}

export function PackageTile({
  position,
  id: package_id,
  duration_seconds,
  offer_listings,
  session_length_seconds,
  price_cents,
}) {
  // Setup

  const offer = (offer_listings && offer_listings.length) > 0 ? offer_listings[0] : null;
  const packagePrice = !!offer ? offer.price.amount : price_cents;

  const { t, ready: translationLoaded } = useTranslation('self-service/packages/package-tile');

  const isHighlight = position === 1;
  const sessionLengthMinutes = session_length_seconds / 60;
  const numSessions = duration_seconds / session_length_seconds;

  // Render

  if (!translationLoaded) {
    return null;
  }

  const tier = t('packageTiers', { returnObjects: true })[position];

  return (
    <div
      className={classnames('package-tile', {
        'package-tile__highlight': isHighlight,
      })}
    >
      {isHighlight && <p className="package-tile__highlight-text">{t('mostPopular')}</p>}
      <Card className="package-tile__card">
        <h3>{_GetTitle(t, tier, duration_seconds)}</h3>
        <hr />
        {!!offer && offer.amount_saved.amount > 0 ? (
          <>
            <h1 className="package-tile__promotion-price">{formatPrice(packagePrice)}</h1>
            <h5>
              <span className="package-tile__original-price">{formatPrice(price_cents)}</span>{' '}
              <span className="package-tile__amount-saved">{`${formatPrice(
                offer.amount_saved.amount
              )} ${t('off')}`}</span>
            </h5>
          </>
        ) : (
          <h1 className="package-tile__package-price">{formatPrice(packagePrice)}</h1>
        )}
        <div className="package-tile__bullets">
          <ul>
            <li>
              {numSessions.toFixed(0)} x {sessionLengthMinutes}-{t('minuteLessons')}
            </li>
            <li>
              {formatPrice(Math.ceil(packagePrice / getHours(duration_seconds)))} / {t('hour')}
            </li>
          </ul>
        </div>
        <div className="package-tile__button-container">
          <a
            href={`/payments/buynow_terminal/index.html?packageId=${package_id}${
              offer ? `&promotionId=${offer.promotion_id}` : ''
            }`}
          >
            <AnalyticsEventTrigger
              analytics={{
                action: 'select-package',
                category: ANALYTICS_CATEGORY,
                label: `id-${package_id}`,
              }}
              element={Button}
              elementProps={{
                className: 'package-tile__button',
                contained: true,
              }}
            >
              {`${t('choose')} ${tier}`}
            </AnalyticsEventTrigger>
          </a>
        </div>
      </Card>
    </div>
  );
}

PackageTile.propTypes = {
  position: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  duration_seconds: PropTypes.number.isRequired,
  price_cents: PropTypes.number.isRequired,
  session_length_seconds: PropTypes.number.isRequired,
};

export default PackageTile;
